/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  KillswitchesGetRequest,
  KillswitchesGetSecurity,
} from "../models/operations/killswitchesget.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  buildKillswitchQuery,
  KillswitchQueryData,
  prefetchKillswitch,
  queryKeyKillswitch,
} from "./killswitch.core.js";
export {
  buildKillswitchQuery,
  type KillswitchQueryData,
  prefetchKillswitch,
  queryKeyKillswitch,
};

export type KillswitchQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * get killswitches
 */
export function useKillswitch(
  security: KillswitchesGetSecurity,
  request: KillswitchesGetRequest,
  options?: QueryHookOptions<KillswitchQueryData, KillswitchQueryError>,
): UseQueryResult<KillswitchQueryData, KillswitchQueryError> {
  const client = useGramContext();
  return useQuery({
    ...buildKillswitchQuery(
      client,
      security,
      request,
      options,
    ),
    ...options,
  });
}

/**
 * get killswitches
 */
export function useKillswitchSuspense(
  security: KillswitchesGetSecurity,
  request: KillswitchesGetRequest,
  options?: SuspenseQueryHookOptions<KillswitchQueryData, KillswitchQueryError>,
): UseSuspenseQueryResult<KillswitchQueryData, KillswitchQueryError> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildKillswitchQuery(
      client,
      security,
      request,
      options,
    ),
    ...options,
  });
}

export function setKillswitchData(
  client: QueryClient,
  queryKeyBase: [parameters: { id: string; gramSession?: string | undefined }],
  data: KillswitchQueryData,
): KillswitchQueryData | undefined {
  const key = queryKeyKillswitch(...queryKeyBase);

  return client.setQueryData<KillswitchQueryData>(key, data);
}

export function invalidateKillswitch(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: { id: string; gramSession?: string | undefined }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "killswitches", "get", ...queryKeyBase],
  });
}

export function invalidateAllKillswitch(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "killswitches", "get"],
  });
}
